export enum AlertSeverity {
    error = 'error',
    info = 'info',
    neutral = 'neutral',
    success = 'success',
    warning = 'warning',
}
